export default "__VITE_ASSET__yBScxfav__";